import gql from "graphql-tag";

export const GET_USER_FAVORITES = gql`
  query GetUserFavorites($userId: ID!) {
    user(id: $userId, idType: DATABASE_ID) {
      databaseId
      favorites
      id
    }
  }
`;
